export default __webpack_public_path__ + "static/media/black-dashboard-react.css.6f428e00.map";